import { Card, CardBody, Col } from 'reactstrap'
import { displayData } from '../../../../Data/Ui-Kits/Typography/Typography'
import { DisplayHeadings } from '../../../../utils/Constant'
import { H2, H3, H4 } from '../../../../AbstractElements'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const DisplayCart = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={DisplayHeadings} span={displayData} />
        <CardBody className="d-flex flex-column gap-2">
          <H2 className="display-1">Display 1</H2>
          <H2 className="display-2">Display 2</H2>
          <H3 className="display-3">Display 3</H3>
          <H4 className="display-4">Display 4</H4>
        </CardBody>
      </Card>
    </Col>
  )
}

export default DisplayCart